import React from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function AuthPage() {
  const { loginWithGoogle, user, loading } = useAuth();
  const nav = useNavigate();

  React.useEffect(() => {
    if (!loading && user) nav("/dashboard", { replace: true });
  }, [user, loading, nav]);

  return (
    <div className="min-h-[70vh] grid md:grid-cols-2 gap-8 items-center">
      <div className="hidden md:block fade-up">
        <div className="text-xs uppercase tracking-[0.2em] text-pink-300 mb-4">One-tap · Free forever</div>
        <h1 className="font-display text-4xl lg:text-5xl font-bold tracking-tighter leading-tight mb-6">
          Sign in with Google and start solving.
        </h1>
        <p className="text-zinc-400 leading-relaxed max-w-md mb-8">
          No forms. Your streaks, bookmarks and quiz history are synced to your Google account.
        </p>
        <div className="grid grid-cols-3 gap-3 max-w-md">
          <div className="rounded-md border border-white/10 bg-white/5 p-3">
            <div className="font-mono text-pink-300 text-lg">7d</div>
            <div className="text-[11px] uppercase tracking-wider text-zinc-500">Streaks</div>
          </div>
          <div className="rounded-md border border-white/10 bg-white/5 p-3">
            <div className="font-mono text-yellow-300 text-lg">2×</div>
            <div className="text-[11px] uppercase tracking-wider text-zinc-500">Daily</div>
          </div>
          <div className="rounded-md border border-white/10 bg-white/5 p-3">
            <div className="font-mono text-green-400 text-lg">AI</div>
            <div className="text-[11px] uppercase tracking-wider text-zinc-500">Tutor</div>
          </div>
        </div>
      </div>
      <div className="fade-up fade-up-1 rounded-lg border border-white/10 bg-[#152040] p-8" data-testid="auth-card">
        <div className="font-display text-2xl font-bold mb-1">Welcome</div>
        <div className="text-sm text-zinc-400 mb-8">Continue with Google to save your progress across devices.</div>
        <Button
          data-testid="google-signin-btn"
          onClick={loginWithGoogle}
          className="w-full h-12 bg-white text-black hover:bg-zinc-200 rounded-full font-semibold"
        >
          <svg width="18" height="18" viewBox="0 0 48 48" className="mr-3" aria-hidden="true">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          Continue with Google
        </Button>
        <div className="text-[11px] text-zinc-500 text-center mt-6 leading-relaxed">
          By continuing you agree to our fair-use policy. We never share your data with third parties.
        </div>
      </div>
    </div>
  );
}
